// extracted by mini-css-extract-plugin
export default {"marginTop":"CategoryLoadingError_marginTop__qr37O","errorBox":"CategoryLoadingError_errorBox__aBh2J","link":"CategoryLoadingError_link__CYME2"};